import { render, staticRenderFns } from "./RestockDialog.vue?vue&type=template&id=22300df4"
import script from "./RestockDialog.vue?vue&type=script&lang=js"
export * from "./RestockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports